/* jshint browser:true,newcap:false */
/* global kx:true,blocks:true */

(function(window, kx) {
	'use strict';

	var App = blocks.Application(),
		Issue = App.Model({
			title: App.Property(),
			description: App.Property()
		}),
		List = App.Collection(Issue);

	App.View('List', {
		list: List([{title: 'Test', description: 'This is a test'}, {title: 'Another', description: 'Example'}])
	});
})(window, kx);
